import './App.css';
import Header from './components/Header';
import HeroVideo from './components/HeroVideo';
import ContentSection from './components/ContentSection';
import TextImageModule from './components/TextImageModule';
// import TwoColumnIntro from './components/TwoColumnIntro';
// import ImageCarousel from './components/ImageCarousel';
// import CardCarousel from './components/CardCarousel';
// import InfoBlock from './components/InfoBlock';
import ContactModule from './components/ContactModule';
import Footer from './components/Footer';
import AttractionsSection from './components/AttractionsSection';
import RoomInfoSection from './components/RoomInfoSection';
import RoomsGrid from './components/RoomsGrid';
import ServicesGrid from './components/ServicesGrid';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import GalleryPreview from './components/GalleryPreview';

import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, observerOptions);

    const revealElements = document.querySelectorAll('.reveal');
    revealElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const detailedServices = [
    {
      icon: '🚗',
      title: 'Cab & Transportation',
      description: 'Reliable cab services for a hassle-free exploration of Jaipur and beyond.',
      subsections: [
        {
          title: 'Local Jaipur Sightseeing',
          items: [
            'Half Day Tour (4-5 hours): 3-4 major attractions',
            'Full Day Tour (8-10 hours): Comprehensive city tour',
            'Popular: Amer Fort, Hawa Mahal, City Palace, Jantar Mantar, Jal Mahal, Nahargarh, Albert Hall, Jaigarh Fort',
            'Shopping Tours: Johari Bazaar, Bapu Bazaar, Tripolia Bazaar'
          ]
        },
        {
          title: 'Jaipur to Khatushyam Ji Temple',
          items: [
            'Distance: ~80 km (1.5-2 hours journey)',
            'Service: Round trip with comfortable waiting time',
            'Options: Sedan, SUV, and larger vehicles available'
          ],
          info: 'Book Your Cab: Contact our front desk or book in advance. Competitive rates and well-maintained vehicles.'
        }
      ]
    },
    {
      icon: '🏛️',
      title: 'Heritage Ambiance',
      description: 'Experience the royal charm of Rajasthan through our thoughtfully designed interiors.',
      highlights: [
        'Traditional Rajasthani artwork and decorative elements',
        'Heritage-inspired furniture and furnishings',
        'Warm colors reflecting Jaipur\'s Pink City heritage',
        'Local handicrafts and traditional decor pieces',
        'Cultural ambiance connecting you to Rajasthan\'s rich history'
      ]
    },
    {
      icon: '✨',
      title: 'Additional Amenities',
      description: 'Comprehensive guest services and modern facilities for your comfort.',
      subsections: [
        {
          title: 'Guest Services',
          items: ['24-hour front desk', 'Room service', 'Laundry service', 'Luggage storage', 'Wake-up call service']
        },
        {
          title: 'Modern Facilities',
          items: ['Free high-speed WiFi', 'Power backup', 'Parking facility', 'CCTV security', 'Daily housekeeping']
        },
        {
          title: 'Travel Assistance',
          items: ['Tourist information', 'Local guide recommendations', 'Sightseeing planning help', 'Restaurant suggestions', 'Ticket booking assistance']
        }
      ]
    }
  ];

  const contactInfo = {
    heading: 'Contact Us & Location',
    description: 'Whether you are planning a stay at The Jaipur Hotels, or have a question about our services, our team is here to help you.',
    address: {
      label: 'OUR ADDRESS',
      lines: [
        'The Jaipur Hotels',
        'Plot No 66 A, RPA Road',
        'Sanjay Colony, Nehru Nagar',
        'Jaipur, Rajasthan 302016',
        'India',
      ],
      mapsLink: 'https://maps.google.com/?q=The+Jaipur+Hotels+Nehru+Nagar',
    },
    suites: {
      label: 'CONTACT INFORMATION',
      phones: [
        { number: '+91 9982226444', label: 'Phone' },
      ],
      email: 'Jivrajsinghrajawat@gmail.com',
      whatsapp: {
        number: '+919982226444',
        description: 'WhatsApp: Available for instant booking',
      },
    },
    general: {
      label: 'RECEPTION HOURS',
      phone: '+91 9982226444',
      email: 'Jivrajsinghrajawat@gmail.com',
    },
  };

  const diningDetails = [
    {
      icon: '🌅',
      title: 'Complimentary Breakfast',
      description: 'Start your day with a delicious variety of fresh options (7:00 AM - 10:30 AM).',
      subsections: [
        {
          title: 'Menu Highlights',
          items: [
            'Traditional options: Poha, Upma, Paratha',
            'South Indian: Idli, Dosa, Vada',
            'Toast, butter, jam & seasonal fruits',
            'Milk, cereals, tea & coffee'
          ],
          info: 'Menu varies daily. Dietary requirements accommodated with prior notice.'
        }
      ]
    },
    {
      icon: '🍽️',
      title: 'Dine-In Options',
      description: 'Freshly prepared lunch and dinner without stepping out of the hotel.',
      subsections: [
        {
          title: 'Cuisine Selection',
          items: [
            'North Indian: Dal, Sabzi, Roti, Paneer',
            'Rajasthani: Dal Baati Churma, Gatte ki Sabzi',
            'Chinese: Noodles, Fried Rice, Manchurian',
            'Snacks & Beverages: Samosas, Chai, Juices'
          ],
          info: 'Lunch: 12:00 PM - 3:00 PM | Dinner: 7:00 PM - 10:30 PM. Charges apply.'
        }
      ]
    },
    {
      icon: '🚭',
      title: 'Smoking Zone',
      description: 'Designated smoking area available for guest comfort and convenience.',
      highlights: [
        'Dedicated smoking area available',
        'Smoke-free rooms and common areas',
        'Ensuring comfort for all our guests'
      ]
    }
  ];

  const footerData = {
    hotels: [
      { label: 'The Jaipur Hotels', url: '#home' },
      { label: 'About Us', url: '#about' },
      { label: 'Rooms & Suites', url: '#rooms' },
      { label: 'Dining', url: '#dining' },
    ],
    residences: [
      { label: 'Services & Facilities', url: '#services' },
      { label: 'Nearby Attractions', url: '#attractions' },
    ],
    mediaAndSales: {
      title: 'Quick Links',
      links: [
        { label: 'Home', url: '#home', external: false },
        { label: 'About Us', url: '#about' },
        { label: 'Rooms', url: '#rooms', external: false },
        { label: 'Contact', url: '#contact' },
      ],
    },
    getToKnowUs: {
      title: 'Get to know us',
      links: [
        { label: 'About The Jaipur Hotels', url: '#about' },
        { label: 'Our Heritage', url: '#about' },
        { label: 'Location & Directions', url: '#contact' },
        { label: 'Booking Terms', url: '#' },
      ],
    },
    socialMedia: [
      { platform: 'instagram', url: '#' },
      { platform: 'facebook', url: '#' },
      { platform: 'twitter', url: '#' },
    ],
    giftsLink: {
      label: 'Attractions',
      url: '#attractions',
      external: false,
    },
    contactLink: {
      label: 'Contact',
      url: '#contact',
    },
    disclaimerLeft: `The Jaipur Hotels
Plot No 66 A, RPA Road
Sanjay Colony, Nehru Nagar
Jaipur, Rajasthan 302016, India`,
    disclaimerRight: `Jivrajsinghrajawat@gmail.com
Phone: +91 9982226444
24/7 Front Desk Service`,
    legalLinks: [
      { label: 'Privacy policy', url: '#' },
      { label: 'Terms of use', url: '#' },
      { label: 'Booking terms', url: '#' },
    ],
    copyrightText: '© 2025 The Jaipur Hotels. All Rights Reserved.',
    developerCredit: {
      text: '© 2025 Developed by Dizital Junction',
      url: 'https://dizitaljunction.com'
    }
  };

  return (
    <div className="App">
      {/* Header with navigation */}
      <Header />

      {/* Hero Section - id="home" */}
      <section id="home">
        <HeroVideo />
      </section>

      {/* About Section - id="about" */}
      <section id="about">
        <div className="reveal">
          <ContentSection />
        </div>
      </section>

      {/* Rooms Section - id="rooms" */}
      <section id="rooms">
        <div className="reveal">
          <TextImageModule
            imagePosition="left"
            preHeading="ROOMS AND SUITES"
            title="Comfortable Living"
            description="All our rooms are designed keeping your comfort in mind. Choose from our Standard and Deluxe rooms, equipped with essential amenities to ensure a pleasant stay."
            imageSrc="/images/WhatsApp Image 2026-01-13 at 8.04.06 PM.jpeg"
            imageAlt="Heritage guest room with traditional decor"
          />
        </div>
        <div className="reveal">
          <RoomsGrid />
        </div>
        <div className="reveal">
          <RoomInfoSection />
        </div>
      </section>

      {/* Gallery Section - id="gallery" */}
      <section id="gallery" style={{ scrollMarginTop: '100px' }}>
        <div className="reveal">
          <GalleryPreview />
        </div>
      </section>

      {/* Dining Section */}
      <section id="dining" style={{ scrollMarginTop: '100px' }}>
        <div className="reveal">
          <ServicesGrid heading="Dining at The Jaipur Hotels" services={diningDetails} />
        </div>
      </section>

      {/* Services Section */}
      <section id="services" style={{ scrollMarginTop: '120px' }}>
        <div className="reveal">
          <ServicesGrid heading="Services & Facilities" services={detailedServices} />
        </div>
      </section>

      {/* Nearby Attractions Section - id="attractions" */}
      <section id="attractions">
        <div className="reveal">
          <AttractionsSection />
        </div>
      </section>

      {/* Contact Section - id="contact" */}
      <section id="contact">
        <div className="reveal">
          <ContactModule
            heading={contactInfo.heading}
            description={contactInfo.description}
            address={contactInfo.address}
            suites={contactInfo.suites}
            general={contactInfo.general}
          />
        </div>
      </section>

      {/* Footer */}
      <div className="reveal">
        <Footer
          hotels={footerData.hotels}
          residences={footerData.residences}
          mediaAndSales={footerData.mediaAndSales}
          getToKnowUs={footerData.getToKnowUs}
          socialMedia={footerData.socialMedia}
          giftsLink={footerData.giftsLink}
          contactLink={footerData.contactLink}
          disclaimerLeft={footerData.disclaimerLeft}
          disclaimerRight={footerData.disclaimerRight}
          legalLinks={footerData.legalLinks}
          copyrightText={footerData.copyrightText}
          developerCredit={footerData.developerCredit}
          signUpText={''} signUpButtonText={''} signUpButtonLink={''}        />
      </div>

      {/* Floating WhatsApp Button */}
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
